import {
  faBook,
  faDesktop,
  faExclamationCircle,
  faInfoCircle,
  faSpinner,
  faUserCircle,
} from '@fortawesome/free-solid-svg-icons';

import {
  faBan,
  faChevronDown,
  faChevronRight,
  faDownload,
  faLockOpen,
  faPencil,
  faPlus,
  faPowerOff,
  faSort,
  faSortDown,
  faSortUp,
  faTrash,
  faUndo,
  faUpload,
} from '@fortawesome/pro-solid-svg-icons';

import {
  faBars,
  faBatteryEmpty,
  faBatteryFull,
  faBatteryHalf,
  faBatteryQuarter,
  faBatteryThreeQuarters,
  faLayerPlus,
  faTimes,
} from '@fortawesome/pro-light-svg-icons';

const fontAwesomeIcons = [
  faBan,
  faPowerOff,
  faBars,
  faBatteryFull,
  faBatteryThreeQuarters,
  faBatteryHalf,
  faBatteryQuarter,
  faBatteryEmpty,
  faChevronRight,
  faChevronDown,
  faDesktop,
  faDownload,
  faTrash,
  faPencil,
  faLockOpen,
  faPlus,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faTimes,
  faUndo,
  faUpload,
  faUserCircle,
  faBook,
  faInfoCircle,
  faLayerPlus,
  faExclamationCircle,
];
export default fontAwesomeIcons;
